import React, { useState, useRef, useEffect } from "react";
import { supabase } from "../utils/supabaseClient";
import "../styles/login-dropdown.css";
import { useNavigate } from "react-router-dom";

const LoginDropdown = () => {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("login"); // login | forgot
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // const login = async () => {
  //   // const { error } = await supabase.auth.signInWithPassword({
  //   //   email,
  //   //   password,
  //   // });
  //   // if (error) alert(error.message);
  //   // else {
  //   //   alert("Login successful");
  //   //   setOpen(false);
  //   // }   
  // };

  const login = () => {
    setOpen(false);
    navigate("/dashboard");
  };

  const sendResetLink = async () => {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    if (error) alert(error.message);
    else alert("Password reset link sent to email");
  };

  return (
    <div className="login-wrapper" ref={ref}>
      <button className="login-icon-btn" onClick={() => setOpen(!open)}>👤</button>

      {open && (
        <div className="login-dropdown">
          {mode === "login" ? (
            <>
              <h4>Login</h4>
              <input
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
              />
              <input
                type="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
              />

              <button className="otp-btn" onClick={login}>Login</button>

              <p className="forgot" onClick={() => setMode("forgot")}>
                Forgot password?
              </p>
            </>
          ) : (
            <>
              <h4>Reset Password</h4>
              <input
                type="email"
                placeholder="Enter your email"
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="otp-btn" onClick={sendResetLink}>
                Send Reset Link
              </button>
              <p className="forgot" onClick={() => setMode("login")}>
                Back to login
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default LoginDropdown;
